import { combineReducers } from 'redux'
import { currencyReducer } from 'core/reducers/reducer-currency'
import { providerReducer } from 'core/reducers/reducer-provider'
import { transactionReducer } from 'core/reducers/reducer-transaction'
import { walletReducer } from 'core/reducers/reducer-wallet'
import { uiReducer } from 'core/reducers/reducer-ui'

const rootReducer = combineReducers({
  currency: currencyReducer,
  provider: providerReducer,
  transaction: transactionReducer,
  ui: uiReducer,
  wallet: walletReducer
})

export default rootReducer
